export default __webpack_public_path__ + "static/media/485.d50b070b.png";